"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantTypes = exports.Switches = void 0;
var Switches;
(function (Switches) {
    Switches["YES"] = "Yes";
    Switches["NO"] = "No";
    Switches["ON"] = "On";
    Switches["OFF"] = "Off";
})(Switches = exports.Switches || (exports.Switches = {}));
var ConstantTypes;
(function (ConstantTypes) {
    ConstantTypes["SCALAR"] = "scalar";
    ConstantTypes["BITS"] = "bits";
    ConstantTypes["ARRAY"] = "array";
    ConstantTypes["STRING"] = "string";
})(ConstantTypes = exports.ConstantTypes || (exports.ConstantTypes = {}));
